import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackTakeABreakInformation = (data: object): void =>
  trackEvent(keys.takeABreakInformation, { data })
export const trackTakeABreakConfirmation = (data: object): void =>
  trackEvent(keys.takeABreakConfirmation, { data })
export const trackTakeABreakAlreadyActive = (data: object): void =>
  trackEvent(keys.takeABreakAlreadyActive, { data })
export const trackTakeABreakCancel = (data: object): void =>
  trackEvent(keys.takeABreakCancel, { data })
export const trackTakeABreakSubmitSelection = (data: object): void =>
  trackEvent(keys.takeABreakSubmitSelection, { data })
export const trackTakeABreakSubmitSucceeded = (data: object): void =>
  trackEvent(keys.takeABreakSubmitSucceeded, { data })
export const trackTakeABreakSubmitFailed = (data: object): void =>
  trackEvent(keys.takeABreakSubmitFailed, { data })
